import React from "react";
import { yupResolver } from "@hookform/resolvers/yup/dist/yup.js";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { formResolver } from "~/pages/Editor/RequisitesPage/schema";
import { Field } from "~/shared/ui/Field";

import { FORM_FOR_ADD, formForAddIProps } from "./option";

import s from "./s.less";

export interface RequisitesFormValues {
  companyName: string;
  fullCompanyName: string;
  inn: string;
  kpp: string;
  ogrn: string;
  legalAddress: string;
  postalAddress: string;
  paymentAccount: string;
  bankName: string;
  correspondentAccount: string;
  bik: string;
  phone: string;
  fax: string;
  okved: string;
  email: string;
  ogrn_date: Date | null;
  ogrn_number: string;
}

interface RequisitesFormIProps {
  formId: string;
  defaultValues: RequisitesFormValues;
  submit: (data: RequisitesFormValues) => void;
}

const RequisitesForm = ({
  formId,
  defaultValues,
  submit,
}: RequisitesFormIProps) => {
  const { t } = useTranslation();

  const { control, handleSubmit, errors } = useForm<RequisitesFormValues>({
    defaultValues: defaultValues,
    resolver: yupResolver(formResolver(t)),
  });

  return (
    <form id={formId} onSubmit={handleSubmit(submit)} className={s.formStyle}>
      <div className={s.wrapperFields}>
        {FORM_FOR_ADD.map(({ type, name }: formForAddIProps) =>
          type === "datePicker" ? (
            <Field
              key={name}
              type="datePicker"
              name={name}
              control={control}
              label={t(`listRequisites.${name}`)}
              error={errors[name]?.message}
              wrapperClassName={s.wrappField}
              format="DD.MM.YYYY"
            />
          ) : (
            <Field
              key={name}
              type="input"
              name={name}
              control={control}
              label={t(`listRequisites.${name}`)}
              error={errors[name]?.message}
              wrapperClassName={s.wrappField}
            />
          ),
        )}
      </div>
    </form>
  );
};

export default RequisitesForm;
